import React, { Fragment } from "react"
import { Box, Typography, useTheme } from "@material-ui/core"
import LockRoundedIcon from "@material-ui/icons/LockRounded"
import { useDispatch } from "react-redux"
import {
  columns,
  crewMobileColumns,
} from "../../../../../pages/Shoot/pages/Billing/BillingContext"
import { toggleFlaggingDialog } from "../../../../../actions/billingDialogs"
import { updateFlagStatusCrewClient } from "../../../../../actions/billing-crew-client"
import { openSnackBar } from "../../../../../actions/snack-bar"
import PropTypes from "prop-types"
import { _toggleLoginDialog } from "../../../../../actions/authentication"
import CrewBillingTotal from "../CrewBillingTotal"
import ExpenseTable from "../../../Common/ExpenseTable/index"

const OriginalItemsTable = ({
  crewDealMemo = {},
  setCrewDealMemo = () => {},
  confirmed = false,
}) => {
  const dispatch = useDispatch()
  const theme = useTheme()

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  const crewMember = crewDealMemo && crewDealMemo.user

  // *** RESOLVE FLAG ***

  const setItemToFlag = (nextStatusObj, expenseId) => {
    // args come from handleFlagDialog function, which accesses them from the expense table
    let crewFlagStatus = {
      crew_flag_status_id: nextStatusObj.crew_flag_status_id,
      crew_flag_comment: nextStatusObj.comment,
    }
    // crewFlagStatus marries the agnostic "comment" from nextStatus obj to the crew-specific flag comment key
    dispatch(updateFlagStatusCrewClient(crewFlagStatus, expenseId))
      .then(() => {
        let newStatusString =
          nextStatusObj.crew_flag_status_id === 4 ? "flagged" : "accepted"
        setCrewDealMemo(oldState => {
          const newExpenses = oldState.user.expenses.map(x => {
            if (x.expense_id === expenseId) {
              return {
                ...x,
                crew_flag_status: newStatusString,
                crew_flag_comment: crewFlagStatus.crew_flag_comment,
              }
            } else {
              return x
            }
          })
          return {
            ...oldState,
            user: { ...oldState.user, expenses: newExpenses },
          }
        })
        dispatch(
          openSnackBar({
            message:
              newStatusString === "flagged"
                ? "Expense item flagged"
                : "Flag removed successfully",
          })
        )
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Flag update was unsuccessful" }))
      })
  }

  const handleFlagDialog = (nextStatus, item, user) => {
    // args come from Expense Table handleFlag fn, not from within this file
    const data = {
      flagFunc: setItemToFlag,
      nextStatus: nextStatus,
      comment: item.crew_flag_comment,
      funcParams: [item.expense_id],
    }
    Object.keys(user).length > 0
      ? dispatch(toggleFlaggingDialog(true, data))
      : dispatch(_toggleLoginDialog(true))
  }

  // *** ADD BLANK ITEM END ***

  return (
    <Box mt={4}>
      <ExpenseTable
        columns={viewportWidth > 600 ? columns : crewMobileColumns}
        data={crewMember}
      >
        <ExpenseTable.Header />
        <ExpenseTable.ItemsGroup>
          <ExpenseTable.ItemBar>
            <ExpenseTable.NameItem
              style={
                viewportWidth < 600
                  ? {
                      gridColumn: "1/ span 6",
                    }
                  : {}
              }
            />
            {viewportWidth > 600 ? (
              <ExpenseTable.NumberItem valueForProperty="quantity" />
            ) : (
              <Box>
                <Typography
                  style={{
                    marginTop: "5px",
                    fontSize: "12px",
                    color: "#9A9A9A",
                    textAlign: "center",
                  }}
                >
                  Qty
                </Typography>
                <ExpenseTable.NumberItem valueForProperty="quantity" />
              </Box>
            )}
            {viewportWidth > 600 ? (
              <ExpenseTable.NumberItem valueForProperty="actual_rate" />
            ) : (
              <Box>
                <Typography
                  style={{
                    marginTop: "5px",
                    fontSize: "12px",
                    color: "#9A9A9A",
                    textAlign: "center",
                  }}
                >
                  Rate($)
                </Typography>
                <ExpenseTable.NumberItem valueForProperty="actual_rate" />
              </Box>
            )}
            {viewportWidth > 600 ? (
              <ExpenseTable.TotalItem>
                {values => (values.actual_rate * values.quantity).toFixed(2)}
              </ExpenseTable.TotalItem>
            ) : (
              <Box>
                <Typography
                  style={{
                    marginTop: "5px",
                    fontSize: "12px",
                    color: "#9A9A9A",
                    textAlign: "center",
                  }}
                >
                  Total($)
                </Typography>
                <ExpenseTable.TotalItem justifyContent="center">
                  {values => (values.actual_rate * values.quantity).toFixed(2)}
                </ExpenseTable.TotalItem>
              </Box>
            )}
            <ExpenseTable.Item
              valueForProperty="description"
              style={
                viewportWidth > 600
                  ? {
                      gridColumn: "type_name-start / quantity-start",
                      gridRow: "2/2",
                    }
                  : {
                      gridRow: "2/3",
                      gridColumn: "1/ span 6",
                    }
              }
            />
            <ExpenseTable.FlagButton onClick={handleFlagDialog} crewView />
          </ExpenseTable.ItemBar>
        </ExpenseTable.ItemsGroup>
        <Box
          display="flex"
          flexDirection={viewportWidth > 600 ? "row" : "column"}
          alignItems="center"
        >
          {/* This moves to below the card when crew confirms it */}
          <Box
            width={viewportWidth > 600 ? "50%" : "100%"}
            display="flex"
            // justifyContent="flex-start"
            alignItems="center"
            color={theme.palette.primary.main}
          >
            {!confirmed && (
              <Fragment>
                <LockRoundedIcon />
                <Typography style={{ marginLeft: 10 }}>
                  For viewing only, the original deal memo can no longer be
                  edited
                </Typography>
              </Fragment>
            )}
          </Box>
          <Box
            width={viewportWidth > 600 ? "50%" : "100%"}
            ml={viewportWidth > 600 ? "20%" : 0}
            mt={viewportWidth > 600 ? 0 : "10px"}
          >
            <CrewBillingTotal data={crewMember} originalOnly />
          </Box>
        </Box>
      </ExpenseTable>
    </Box>
  )
}

OriginalItemsTable.propTypes = {
  crewDealMemo: PropTypes.object,
  setCrewDealMemo: PropTypes.func,
  confirmed: PropTypes.bool,
}

export default OriginalItemsTable
